(() => {
  if (window.peCROReady) return;
  window.peCROReady = true;
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initializeShortcuts = (scope = document) => {
    scope.querySelectorAll('[data-pe-mobile-purchase]').forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const section = bar.closest('[data-product-main]');
      const form = section?.querySelector('.product-form');
      const add = section?.querySelector('[data-add-button]');
      if (!form || !add || !('IntersectionObserver' in window)) return;
      let sectionVisible = false;
      let addVisible = false;
      const update = () => { bar.hidden = !sectionVisible || addVisible; };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === section) sectionVisible = entry.isIntersecting;
          if (entry.target === add) addVisible = entry.isIntersecting;
        });
        update();
      });
      observer.observe(section);
      observer.observe(add);
      bar.querySelector('button').addEventListener('click', () => {
        form.scrollIntoView({ behavior: reducedMotion() ? 'instant' : 'smooth', block: 'center' });
        const target = form.querySelector('[data-option-position]:checked') || form.querySelector('[data-option-position]') || add;
        target.focus({ preventScroll: true });
      });
      section.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    });
  };

  const modal = document.querySelector('[data-pe-quick-view-modal]');
  const content = modal?.querySelector('[data-pe-quick-view-content]');
  const status = modal?.querySelector('[data-pe-quick-view-status]');
  let controller;
  let opener;
  let unsubscribe;

  const mountProduct = () => {
    const root = content.querySelector('[data-pe-quick-product]');
    if (!root) throw new Error('Missing quick view product');
    const form = root.querySelector('form');
    if (!form) return;
    const variants = JSON.parse(root.querySelector('[data-pe-quick-variants]').textContent);
    const radios = [...root.querySelectorAll('[data-pe-option]')];
    const idInput = form.querySelector('[name=id]');
    const submit = form.querySelector('[type=submit]');
    const label = submit.querySelector('span');
    const price = root.querySelector('[data-pe-quick-price]');
    const toggle = root.querySelector('[data-pe-quick-customize]');
    const fields = root.querySelector('[data-pe-quick-fields]');
    const updateVariant = () => {
      const options = [];
      radios.forEach((input) => { if (input.checked) options[Number(input.dataset.peOption) - 1] = input.value; });
      const complete = root.dataset.defaultVariant === 'true' || (options.length === Number(root.dataset.optionsCount) && Array.from(options).every(Boolean));
      const variant = complete ? variants.find((v) => root.dataset.defaultVariant === 'true' || v.options.every((value, index) => value === options[index])) : null;
      idInput.value = variant?.available ? variant.id : '';
      submit.disabled = !variant?.available;
      label.textContent = !complete ? root.dataset.chooseLabel : variant?.available ? root.dataset.addLabel : root.dataset.unavailableLabel;
      if (variant) price.textContent = variant.price;
    };
    radios.forEach((radio) => radio.addEventListener('change', updateVariant));
    toggle?.addEventListener('change', () => {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input').forEach((input) => { input.disabled = !toggle.checked; });
    });
    form.addEventListener('submit', (event) => {
      if (!idInput.value || submit.disabled) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    updateVariant();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!modal.open || event.source !== 'product-form' || String(event.productVariantId) !== String(idInput.value)) return;
        document.querySelector('cart-drawer')?.setActiveElement(opener);
        modal.close();
      });
    }
  };

  const openQuickView = async (button) => {
    if (!modal || !content || modal.open) return;
    opener = button;
    controller?.abort();
    controller = new AbortController();
    content.replaceChildren();
    status.textContent = modal.dataset.loadingLabel;
    status.hidden = false;
    modal.showModal();
    modal.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(button.dataset.peQuickView, location.origin);
      if (url.origin !== location.origin) throw new Error('Unexpected product origin');
      url.searchParams.set('section_id', 'pe-quick-view');
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Product could not be loaded');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = doc.querySelector('[data-pe-quick-product]');
      if (!product) throw new Error('Product unavailable');
      if (!modal.open) return;
      content.appendChild(product);
      mountProduct();
      status.hidden = true;
      document.dispatchEvent(new CustomEvent('pe:quick-view', { detail: { productId: product.dataset.productId } }));
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = modal.dataset.errorLabel;
      const link = document.createElement('a');
      link.href = button.dataset.peQuickView;
      link.className = 'pe-quick-view__details';
      link.textContent = modal.dataset.detailsLabel;
      content.replaceChildren(link);
    } finally { modal.removeAttribute('aria-busy'); }
  };
  modal?.querySelector('[data-pe-quick-close]').addEventListener('click', () => modal.close());
  modal?.addEventListener('click', (event) => { if (event.target === modal) { const r = modal.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close(); } });
  modal?.addEventListener('close', () => { controller?.abort(); unsubscribe?.(); unsubscribe = null; modal.removeAttribute('aria-busy'); });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pe-quick-view]');
    if (button) { event.preventDefault(); openQuickView(button); return; }
    const guideButton = event.target.closest('[data-size-guide-open]');
    if (guideButton && !event.defaultPrevented) {
      const guide = guideButton.closest('.shopify-section')?.querySelector('[data-size-guide-modal]');
      if (guide && !guide.open) { event.preventDefault(); guide.showModal(); }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (!event.target.matches('[data-size-guide-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...event.target.closest('[role=tablist]').querySelectorAll('[role=tab]')];
    const index = tabs.indexOf(event.target);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault(); tabs[next].click(); tabs[next].focus();
  });
  initializeShortcuts();
  document.addEventListener('shopify:section:load', (event) => initializeShortcuts(event.target));
})();

(() => {
  const mobile = matchMedia("(max-width:749px)");
  const sync = (scope = document) => {
    const offers = [...scope.querySelectorAll("pe-bf-rotating-offer")];
    if (scope.matches?.("pe-bf-rotating-offer")) offers.push(scope);
    offers.forEach(offer => {
      const card = offer.closest(".pe-bf-card-preview");
      const slot = card?.querySelector(".pe-bf-offer-mobile-slot");
      if (!slot) return;
      if (mobile.matches && offer.parentElement !== slot) {
        const marker = document.createComment("quantity offer desktop position");
        offer.before(marker);
        offer.desktopMarker = marker;
        slot.append(offer);
      } else if (!mobile.matches && offer.desktopMarker?.isConnected) {
        const marker = offer.desktopMarker;
        marker.before(offer);
        marker.remove();
        offer.desktopMarker = null;
      }
    });
  };
  mobile.addEventListener("change", () => sync());
  document.addEventListener("shopify:section:load", event => sync(event.target));
  sync();
  new MutationObserver(mutations => {
    mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
      if (node instanceof Element) sync(node);
    }));
  }).observe(document.documentElement, { childList:true, subtree:true });
})();
